import { inject, Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import { HubtypeUser } from 'models/hubtype-user'
import { filter, map, withLatestFrom } from 'rxjs/operators'
import { UpdateMeAction } from 'src/app/actions/auth'
import * as UserActions from 'src/app/actions/user'
import { getMeState } from 'src/app/reducers'
@Injectable({
  providedIn: 'root',
})
export class AuthEffects {
  actions$ = inject(Actions)
  store = inject(Store)

  changeUserStatus$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserActions.changeUserStatus),
      withLatestFrom(this.store.select(getMeState)),
      filter(([action, me]) => me.id === action.userId),
      map(([action, me]) => {
        const updatedUser = {
          ...me,
          status: action.status,
        } as HubtypeUser

        return new UpdateMeAction(updatedUser)
      })
    )
  )
}
